import { render, staticRenderFns } from "./touristExplain.vue?vue&type=template&id=37b108fc&scoped=true&"
import script from "./touristExplain.vue?vue&type=script&lang=js&"
export * from "./touristExplain.vue?vue&type=script&lang=js&"
import style0 from "./touristExplain.vue?vue&type=style&index=0&id=37b108fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b108fc",
  null
  
)

component.options.__file = "touristExplain.vue"
export default component.exports